import * as React from 'react';
import { classNames } from '@features/utils/reactFunctions';

import * as style from '../../CelsiusClaimPageStyles.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

export const UnverifiedState = () => (
  <div className={style.headerWrapperPadding}>
    <h1 className={style.headerTitle}>Verification required</h1>
    <p className={style.headerText}>
    In order to use the Celsius Claim feature, please proceed to the BF Identity application to confirm your identity
    </p>
    <a
      className={classNames(elements.btn, style.actionButton, style.linkBtn)}
      href='/redirect_to_identity'
    >
      Proceed to BF Identity
    </a>
  </div>
);
